import React, { useState, useContext, useRef, useEffect } from "react";
import useForm from "../../../../services/UseForm";
import '../../../../css/payment.css';
import '../../../../css/paymentBill.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { POSContent } from "../pos";
import { UserContext } from "../../../../App";
import logo from '../../../../img/logo/qrcafe.jpg';
import kip100000 from '../../../../img/kip/100000kip.jpg';
import kip10000 from '../../../../img/kip/10000kip.jpg';
import kip1000 from '../../../../img/kip/1000kip.jpg';
import kip20000 from '../../../../img/kip/20000kip.jpg';
import kip2000 from '../../../../img/kip/2000kip.jpg';
import kip50000 from '../../../../img/kip/50000kip.jpg';
import kip5000 from '../../../../img/kip/5000kip.jpg';
import kip500 from '../../../../img/kip/500kip.jpg';
import { useReactToPrint } from 'react-to-print';

axios.defaults.baseURL = API;

function Payment(props) {

    function getDate() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        return `${year}-${month}-${date} ${time}`;
    }

    const {setShowAlert, setErrorMessage, TempOrder, setTempOrder, PaymentTypeList, DiscountList, 
        showPayment, setShowPayment, CurrencyList, subTotal, setSubTotal, NetTotal, setNetTotal, NewNetTotal, setNewNetTotal, setTableList, setShowOrder, 
        QueueID, setQueueID, QueueNumber, setQueueNumber, Tax, setTax} = useContext(POSContent);
    const {userID, LocationID, UserName, LocationName, Address, Tell, device, setDevice, status, setStatus, EPSON_VENDOR_ID,deviceBluetooht, setDeviceBluetooht, statusBluetooht, setStatusBluetooht} = useContext(UserContext);
    const componentRef = useRef();

    const [TransactionID, setTransactionID] = useState("");
    const [PaymentTypeID, setPaymentTypeID] = useState();
    const [PaymentType, setPaymentType] = useState("");

    const [PaidAmount, setPaidAmount] = useState();
    const [PaidMoreAmount, setPaidMoreAmount] = useState();
    const [DiscountAmount, setDiscountAmount] = useState(0);
    const [ChangeAmount, setChangeAmount] = useState(0);
    const [DiscountPercent, setDiscountPercent] = useState(0);
    const [DiscountType, setDiscountType] = useState(0);
    const [disblebtnpayment, setDisblebtnpayment] = useState(1);

    const [gPaidAmount, setgPaidAmount] = useState(0);
    
    const [MemberID, setMemberID] = useState("");
    const [MemberNO, setMemberNO] = useState("");
    const [MemberName, setMemberName] = useState("0");
    const [MemberNewAmount, setMemberNewAmount] = useState(0);
    const [MemberAmount, setMemberAmount] = useState(0);
    const [MemberPoint, setMemberPoint] = useState(0);
    const [MemberNewPoint, setMemberNewPoint] = useState(0);

    const [GiftCardID, setGiftCardID] = useState("");
    const [GiftCardNO, setGiftCardNO] = useState("");
    const [GiftCardAmount, setGiftCardAmount] = useState(0);

    const [RewardCardID, setRewardCardID] = useState("");
    const [RewardCardNO, setRewardCardNO] = useState("");
    const [RewardName, setRewardName] = useState("0");
    const [RewardNewPoint, setRewardNewPoint] = useState(0);
    const [RewardPoint, setRewardPoint] = useState(0);
    const [loading, setLoading] = useState(false);


    const [PrintCount, setPrintCount] = useState(2);

    const [TotalPaidAmount, setTotalPaidAmount] = useState(0);
    const [PaidAmountByCurrency, setPaidAmountByCurrency] = useState(0);

    const [InputClick, setInputClick] = useState(0);

    function currencyFormat(num) {
        if (num !== "") {
            if(num >= 0 || num <= 0){
                return Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
        } 
    }

//  1. Connect to the Printer via USB
  const connectPrinter = async () => {
        try {
            setStatus('Connecting...');
            
            // Request permission to access the USB device
            const selectedDevice = await navigator.usb.requestDevice({
                filters: [{ vendorId: EPSON_VENDOR_ID }]
            });

            await selectedDevice.open();
            
            // Select configuration (most USB printers use configuration 1)
            if (selectedDevice.configuration === null) {
                await selectedDevice.selectConfiguration(1);
            }
            
            // Claim the primary interface (usually interface 0)
            await selectedDevice.claimInterface(0);

            setDevice(selectedDevice);
            setStatus(`Connected to: ${selectedDevice.productName || 'Epson Printer'}`);
            } catch (error) {
                console.error('USB Connection Error:', error);
                setStatus(`Connection failed: ${error.message}`);
            }
    };

    let receipt = '';
    const ESC = '\x1B';
    const GS = '\x1D';
    const CMD = {
        INIT: ESC + '@',             // Initialize printer
        ALIGN_LEFT: ESC + 'a\x00',   // Left alignment
        ALIGN_CENTER: ESC + 'a\x01', // Center alignment
        ALIGN_RIGHT: ESC + 'a\x02',  // Right alignment
        FONT_NORMAL: ESC + '!', // Select normal font (Font A)
        FONT_Size: ESC + '!' + 1,     
        FONT_SizeNomal: ESC + '!' + 0,    
        FONT_BOLD: ESC + 'E\x01',    // Turn on bold
        FONT_REGULAR: ESC + 'E\x00', // Turn off bold
        FEED_CUT: GS + 'V\x41\x03',  // Feed paper and cut (Partial cut)
    };

  // Utility to pad out text to exactly 42 characters for flawless right alignment
    const formatLeftRight = (leftText, rightText, maxChars = 48) => {
        const spacesNeeded = maxChars - (leftText.length + rightText.length);
        if (spacesNeeded <= 0) {
        return leftText.substring(0, maxChars - rightText.length - 1) + ' ' + rightText + '\n';
        }
        return leftText + ' '.repeat(spacesNeeded) + rightText + '\n';
    };

    const PrintBillDetail = (gTransactionID) => {
        setLoading(true);
        let receipt = '';

        // 1. Initialize Printer
        receipt += CMD.INIT;

        // 2. Header Section (Centered)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + 'Manee Arabica Coffee'.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += `${Address}\n`;
        receipt += `Tel: (+856) ${Tell}\n`;
        receipt += '-'.repeat(48) + '\n'; // Divider

        // 3. Metadata Section (Left Aligned)
        receipt += CMD.ALIGN_CENTER;
        receipt += CMD.FONT_BOLD + `Queue NO: ${QueueNumber}`.toUpperCase() + '\n';
        receipt += CMD.FONT_REGULAR;
        receipt += CMD.ALIGN_LEFT;
        receipt += `BILL ID# ${gTransactionID}\n`;
        receipt += `Date: ${new Date().toLocaleDateString()}\n`;
        receipt += `Cashier: ${UserName}\n`;
        receipt += '-'.repeat(48) + '\n';


        // 4. Items Loop (Dynamic Columns Formatting)
        receipt += ("Item/Qty                                   Price\n");
        receipt += '='.repeat(48) + '\n';
        TempOrder.forEach((item) => {
        const quantityText = `${item.Quantity}x  ${currencyFormat(item.Retail_Price)}`;
        const totalText = `${(item.Quantity * item.Retail_Price)}`;

        // Row 1: Print Item Name (Wrap safely if too long)
        if (item.EngName.length > 48) {
            receipt += item.EngName.substring(0, 48) + '\n';
        } else {
            receipt += item.EngName + '\n';
        }

        // Row 2: Sub-row containing calculated item metrics right aligned
        receipt += formatLeftRight(`  ${quantityText}`, currencyFormat(totalText));
        });

        receipt += '-'.repeat(48) + '\n';

        // 5. Totals Section
        receipt += formatLeftRight("Subtotal:", `${currencyFormat(subTotal)}`);
        receipt += formatLeftRight("Discount:", `${currencyFormat(DiscountAmount || 0)}`);
        
        // Bold total row
        receipt += CMD.FONT_BOLD;
        receipt += formatLeftRight("TOTAL:", `${currencyFormat(NewNetTotal)}`);
        receipt += CMD.FONT_REGULAR;
        receipt += '='.repeat(48) + '\n';
        if(PaymentType == "Member" || PaymentType == "MEMBER"){
            receipt += formatLeftRight("PaymentType:", `${PaymentType}`);
            receipt += formatLeftRight("Card Number:", `${MemberNO}`);
            receipt += formatLeftRight("Name:", `${MemberName}`);
            receipt += formatLeftRight("PaidAmount:", `${currencyFormat(PaidAmount)}`);
            receipt += formatLeftRight("ChangeAmount:", `${currencyFormat(ChangeAmount)}`);
            receipt += formatLeftRight("Previous Point:", `${currencyFormat(MemberPoint)}`);
            receipt += formatLeftRight("New Point:", `${currencyFormat(MemberNewPoint)}`);
            
        } else {
            receipt += formatLeftRight("PaymentType:", `${PaymentType}`);
            receipt += formatLeftRight("PaidAmount:", `${currencyFormat(PaidAmount)}`);
            receipt += formatLeftRight("ChangeAmount:", `${currencyFormat(ChangeAmount)}`);
        }

        receipt += '='.repeat(48) + '\n';
        receipt += formatLeftRight("Total Before VAT:", `${currencyFormat((subTotal-Tax))}`);
        receipt += formatLeftRight("VAT(10%):", `${currencyFormat(Tax)}`);
        receipt += formatLeftRight("Total:", `${currencyFormat(NewNetTotal)}`);
        receipt += '='.repeat(48) + '\n';
        // 6. Footer & Auto-Cut
        receipt += CMD.ALIGN_CENTER;
        receipt += "Thank you for your visit!\n";
        receipt += "Please come again\n\n\n\n"; // Feeds space before cutting
        receipt += CMD.FEED_CUT;

        // Convert string to Uint8Array for binary transmission
        const encoder = new TextEncoder();
        const uint8Array = encoder.encode(receipt);
        
        setLoading(false);
        return uint8Array;
    };

    const handlePrintBill = async (gTransactionID) => {
        if(device){
            const endpointOut = device.configuration.interfaces[0].alternate.endpoints.find(
                (ep) => ep.direction === 'out' && ep.type === 'bulk'
            );
            const endpointNumber = endpointOut.endpointNumber;
            for (let i = 0; i < PrintCount; i++) {
                const rawBuffer = PrintBillDetail(gTransactionID);
                await device.transferOut(endpointNumber, rawBuffer);
            }
        } else {
            connectPrinter();
        }
    };

    const handleInputPrintCount = event => { 
        const { name, value } = event.target;
        setPrintCount(value)
    };

    const CalculateChangeAmount = (paidAmount, PaidMoreAmount, DiscountAmount, memberAmount, newNetTotal, memberNO, memberPoint, memberNewPoint) => {
        if (NetTotal > 0) {
            let gPaidAmount = 0;
            let gPaidMoreAmount = 0;
            let gDiscountAmount = 0;
            if(paidAmount > 0){
                gPaidAmount = paidAmount;
            }
            if(PaidMoreAmount > 0){
                gPaidMoreAmount = PaidMoreAmount;
            } 
            if(DiscountAmount > 0)
            {
                gDiscountAmount=DiscountAmount;
            }
            if(gPaidAmount >0){
                var change = (Number(gPaidAmount) + Number(gPaidMoreAmount)) - (Number(NewNetTotal));
            }
            
            if(PaymentType == "Member"){
                if(memberAmount >= (Number(NewNetTotal) - Number(gDiscountAmount)))
                    setMemberNewAmount((Number(memberAmount) + Number(gDiscountAmount)) - (Number(NewNetTotal)));
                else
                    setMemberNewAmount(0);
            } else if(PaymentType == "Gift Card"){
                change = 0;
            }
            var totalpaidAmount = (Number(gPaidAmount) + Number(gPaidMoreAmount));
            setTotalPaidAmount(totalpaidAmount);
            setChangeAmount(change);
            setgPaidAmount(totalpaidAmount);
            localStorage.setItem("DiscountAmount", JSON.stringify(gDiscountAmount));
            localStorage.setItem("PaidAmount", JSON.stringify(totalpaidAmount));
            localStorage.setItem("ChangeAmount", JSON.stringify(change));
            createTempTotal(totalpaidAmount, change, gDiscountAmount, newNetTotal, memberNO, memberPoint, memberNewPoint);
        } else {
            createTempTotal(0, 0, 0, NewNetTotal);
        }
    }

    const CalculateDiscount = (discountPercent) => {
        var gDiscountAmount = 0;
        var NewNetTotal = NetTotal;
        var gIscount = (Number(NetTotal) * (Number(discountPercent) / Number(100))).toFixed(0);
        var roundUp = gIscount.toString().substr(-3, 3);
        var tax = 0;
        if(roundUp > 500){
            gDiscountAmount = (Number(gIscount) - Number(roundUp)) + 1000;
            NewNetTotal = Number(NetTotal) - Number(gDiscountAmount);
        } else if(roundUp < 500) {
            gDiscountAmount = (Number(gIscount) - Number(roundUp));
            NewNetTotal = Number(NetTotal) - Number(gDiscountAmount);
        } else {
            gDiscountAmount = gIscount;
            NewNetTotal = Number(NetTotal) - Number(gIscount);
        }

        setDiscountAmount(gDiscountAmount);
        setNewNetTotal(NewNetTotal);
        CalculateChangeAmount(PaidAmount, PaidMoreAmount, gDiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
    }

    const handleInputChange = event => {
        const {value } = event.target;
        const re = /^[0-9\b]+$/;
        if (value) {
            if (value === '' || re.test(value.split(',').join(''))) {
                setPaidAmount(value.split(',').join(''));
                CalculateChangeAmount(value.split(',').join(''), PaidMoreAmount, DiscountAmount, MemberNewAmount, NewNetTotal, "", 0, 0);
            }  
        } else {
            setPaidAmount();
            CalculateChangeAmount(0, PaidMoreAmount, DiscountAmount, MemberNewAmount, NewNetTotal, "", 0, 0);
        }
    };

    const handleInputClick = (e) => {
        setInputClick(e);
    };

    const hanldeclickMoney = (money) => {
        if(!InputClick & PaymentType != "Member" & PaymentType != "MEMBER"){
            if(PaidAmount > 0){
                var totalpaidAmount = Number(PaidAmount) + Number(money);
                setPaidAmount(totalpaidAmount);
                CalculateChangeAmount(totalpaidAmount, PaidMoreAmount, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            } else{
                setPaidAmount(money);
                CalculateChangeAmount(money, PaidMoreAmount, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            }
        } else {
            if(PaidMoreAmount > 0){
                var totalpaidMoreAmount =Number(PaidMoreAmount) + Number(money);
                setPaidMoreAmount(totalpaidMoreAmount);
                CalculateChangeAmount(PaidAmount, totalpaidMoreAmount, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            } else {
                setPaidMoreAmount(money);
                CalculateChangeAmount(PaidAmount, money, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            }
        }
    }

    const handleChangeDiscount = (event) => {
        const { value } = event.target;
        var tax = 0;
        const re = /^[0-9\b]+$/;
        console.log(value)
        if (value) {
            if (value === '' || re.test(value.split(',').join(''))) {
                var discount = Number(value.split(',').join(''))
                var newNetTotal = Number(NetTotal) - Number(discount);
                setDiscountAmount(discount);
                setNewNetTotal(newNetTotal);
                CalculateChangeAmount(PaidAmount, PaidMoreAmount, discount, MemberAmount, newNetTotal, "", 0, 0)
            }  
        } 
        else {
            setDiscountAmount(0);
            setNewNetTotal(NetTotal);
            CalculateChangeAmount(PaidAmount, PaidMoreAmount, 0, MemberAmount, NetTotal, "", 0, 0)
        }
    }

    const handleInputMoreCashChange = event => {
        const { value } = event.target;
        const re = /^[0-9\b]+$/;
        if (value) {
            if (value === '' || re.test(value.split(',').join(''))) {
                setPaidMoreAmount(value.split(',').join(''));
                CalculateChangeAmount(PaidAmount, value.split(',').join(''), DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            }  
        } else {
            setPaidMoreAmount();
            CalculateChangeAmount(PaidAmount, 0, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
        }
    };

    const handleSelectDiscountType = (e) => {
        var data = DiscountList.filter(function (item) {
            return item.DiscountType == e.target.value
        })
        if (data.length > 0) {
            setDiscountPercent(data[0].Discount);
            CalculateDiscount(data[0].Discount);
            setDiscountType(data[0].DiscountType);
        } else {
            setDiscountPercent("");
            setDiscountType("");
            CalculateDiscount(0);
            setNetTotal(subTotal);
            CalculateChangeAmount(PaidAmount, PaidMoreAmount, 0, MemberAmount, subTotal, "", 0, 0)
        }
    };

    const handleSelectPaymentType = (e) => {
        var data = PaymentTypeList.filter(function (item) {
            return item.PaymentType === e.target.value
        })
        if (data.length > 0) {
            if(data[0].PaymentType == "Cash" || data[0].PaymentType == "CASH"){
                setPaidMoreAmount();
                CalculateChangeAmount(PaidAmount, 0, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            } else if(data[0].PaymentType == "Member" || data[0].PaymentType == "Gift Card") {
                setPaidAmount();
                CalculateChangeAmount(0, PaidMoreAmount, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            }
            setPaymentTypeID(data[0].PaymentTypeID);
            setPaymentType(data[0].PaymentType);
        } else {
            setPaymentTypeID("");
            setPaymentType("");
        }
    };

    const CalculatePoint = (Point) => {
        if(NetTotal >= 20000){
            if(PaymentType == "Member" || PaymentType == "MEMBER") {
                var gPoint = ((Number(NetTotal) / Number(20000)) * 1).toFixed(0);
                setMemberNewPoint(Number(gPoint) + Number(Point));
                // setRewardNewPoint(0);
                return gPoint;
            } 
            // else {
            //     var gPoint = (Number(NetTotal) / Number(20000)).toFixed(0);
            //     setRewardNewPoint(Number(gPoint) + Number(Point));
            //     setMemberNewPoint(0);
            // }
        } else { 
             if(PaymentType == "Member" || PaymentType == "MEMBER") {
                setMemberNewPoint(Point);
                return Point;
             }
        }
    }

    async function handleSearchMembers(event) {
        const { name, value } = event.target;
        setMemberNO(value);
        let token = localStorage.getItem("token");
        var data = {
            MemberNO: value
        }
        setMemberID("");
        setGiftCardID("");
        setRewardCardID("");
        await axios.post("/searchMember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let memberData = response?.data;
            if(memberData.length > 0){
                setPaidAmount(memberData[0].Amount);
                setMemberID(memberData[0].MemberID);
                setMemberName(memberData[0].FirstName + ' ' + memberData[0].LastName);
                setMemberAmount(memberData[0].Amount);
                setMemberPoint(memberData[0].Point);
                CalculatePoint(memberData[0].Point);
                CalculateChangeAmount(memberData[0].Amount, PaidMoreAmount, DiscountAmount, memberData[0].Amount, NewNetTotal, value, memberData[0].Point,  CalculatePoint(memberData[0].Point));
            } else {
                setPaidAmount();
                setMemberID("");
                setMemberName("");
                setMemberAmount(0);
                setMemberPoint(0);
                setMemberNewPoint(0);
                CalculateChangeAmount(0, PaidMoreAmount, DiscountAmount, 0, NewNetTotal, "", 0, 0);
            }
    
        }).catch((err) => {
            console.log(err);
        });
    };

    async function handleSearchGiftCard(event) {
        const { name, value } = event.target;
        setGiftCardNO(value);
        let token = localStorage.getItem("token");
        var data = {
            GiftCardNO: value,
        }
        setMemberID("");
        setGiftCardID("");
        setRewardCardID("");
        await axios.post("/searchGiftCard", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let memberData = response?.data;
            if(memberData.length > 0){
                setGiftCardID(memberData[0].GiftCardID);
                setGiftCardAmount(memberData[0].Price);
                setPaidAmount(memberData[0].Price);
                CalculateChangeAmount(memberData[0].Price, PaidMoreAmount, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            } else {
                setGiftCardID(0);
                setGiftCardAmount(0);
                setPaidAmount();
                CalculateChangeAmount(0, PaidMoreAmount, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
            }
    
        }).catch((err) => {
            console.log(err);
            setGiftCardID(0);
            setGiftCardAmount(0);
            setPaidAmount();
            CalculateChangeAmount(0, PaidMoreAmount, DiscountAmount, MemberAmount, NewNetTotal, "", 0, 0);
        });
    };

    async function handleSearchRewardCard(event) {
        const { name, value } = event.target;
        setRewardCardNO(value);
        setMemberID("");
        setGiftCardID("");
        setRewardCardID("");
        let token = localStorage.getItem("token");
        await axios.get(`/searchRewardCard/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let memberData = response?.data;
            if(memberData.length > 0){
                setRewardCardID(memberData[0].RewardCardID);
                setRewardName(memberData[0].FirstName + ' ' + memberData[0].LastName);
                setRewardPoint(memberData[0].Point);
                CalculatePoint(memberData[0].Point);
            } else {
                setRewardCardID("");
                setRewardName("");
                setRewardPoint(0);
                setRewardNewPoint(0);
            }
        }).catch((err) => {
            console.log(err);
            setRewardCardID("");
            setRewardName("");
            setRewardPoint(0);
            setRewardNewPoint(0);
        });
    };

    async function saveTutorial() {
        if(!PaymentTypeID){
            setErrorMessage("ກະລຸນາເລືອກປະເພດຈ່າຍ");
            setShowAlert(true);
        } else {
            // connectPrinter();
            let gPaidAmount = 0;
            let gPaidMoreAmount = 0;
            if(PaidAmount > 0){
                gPaidAmount = PaidAmount;
            }
            if(PaidMoreAmount > 0){
                gPaidMoreAmount = PaidMoreAmount;
            } 
            if((Number(gPaidAmount) + Number(gPaidMoreAmount)) >= NewNetTotal){
                setDisblebtnpayment("")
                CreateTransaction();
            } else {
                setErrorMessage("ຍອດຈ່າຍບໍ່ພຽງພໍ");
                setShowAlert(true);
            }
        }
    };

    async function CreateTransaction(){
        let token = localStorage.getItem("token");
            let gPaidMoreAmount = 0;
            let gDiscountAmount = 0;
            if(PaidMoreAmount > 0){
                gPaidMoreAmount = PaidMoreAmount;
            } 
            if(DiscountAmount > 0)
            {
                gDiscountAmount=DiscountAmount;
            }
        var data = {
            SubTotal: subTotal,
            GiftCardID: GiftCardID,
            MemberID: MemberID,
            RewardCardID: RewardCardID,
            PreviousPoint: MemberPoint,
            Point: MemberNewPoint,
            Discount: gDiscountAmount,
            NetTotal: NewNetTotal,
            PaidAmount: Number(TotalPaidAmount),
            PaidMoreAmount: gPaidMoreAmount,
            ChangeAmount: ChangeAmount,
            PaymentTypeID: PaymentTypeID,
            LocationID: LocationID,
            Tax: Number(Tax),
            CreatedByID: userID,
            CreatedDate:  getDate(),
            StatusID: 1,
        }
        await axios.post("/createTransaction", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            setTransactionID(response?.data?.insertId)
            if(PaymentType == "Member" || PaymentType == "MEMBER"){
                UpdateMember();
            } else if (PaymentType == "Gift Card" || PaymentType == "GIFT CARD"){
                UpdateGiftCard();
            } else if (RewardCardID > 0) {
                UpdateRewardCard();
            } 
            // handlePrint();
            CreateTransactionDetail(response?.data?.insertId);
            CreateQueue();
            // UpdateTemOrder();
            // PrintPaymentBill(response?.data?.insertId);
            handlePrintBill(response?.data?.insertId);
            ClearData();
        }).catch((err) => {
            console.log(err);
        });
    }

    async function createTempTotal (totalpaidAmount, change, gDiscountAmount, newNetTotal, memberNO, memberPoint, memberNewPoint) {
        let token = localStorage.getItem("token");
        let data;
        data = {
            SubTotal: subTotal,
            Discount: gDiscountAmount || 0,
            NetTotal: newNetTotal || 0,
            PaidAmount: totalpaidAmount || 0,
            ChangeAmount: change || 0,
            MemberNO: memberNO,
            PreviousPoint: memberPoint,
            NewPoint: memberNewPoint,
            LocationID: LocationID,
        };
        console.log(data)
        await axios.post("/CreateTempTotal", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    async function UpdateMember() {
        let token = localStorage.getItem("token");
        var data = {
            MemberID: MemberID,
            Amount: MemberNewAmount,
            Point: MemberNewPoint,
        }
        await axios.post("/usemember", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    };

    async function UpdateGiftCard() {
        let token = localStorage.getItem("token");
        var data = {
            GiftCardID: GiftCardID ,
            StatusID: 2,
        }
        await axios.post("/useGiftCard", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    };

    async function UpdateRewardCard() {
        let token = localStorage.getItem("token");
        var data = {
            RewardCardID: RewardCardID,
            Point: RewardNewPoint,
        }
        await axios.post("/useRewardCard", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    };

    async function CreateTransactionDetail(TransactionID) {
        let token = localStorage.getItem("token");
        if(TempOrder.length > 0) {
            for (var i=0; i < TempOrder.length; i++) {
                var list;
                list ={
                    TransactionID: TransactionID,
                    ProductID: TempOrder[i].ProductID,
                    Quantity: TempOrder[i].Quantity,
                    Retail_Price: TempOrder[i].Retail_Price,
                    SubTotal: TempOrder[i].SubTotal,
                    Sugar: TempOrder[i].Sugar,
                };
                await axios.post("/createTransactionDetail", list, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                    getStoreInventory(TempOrder[i].ProductID, TempOrder[i].Quantity)
                }).catch((err) => {
                    console.log(err);
                });
            } 
            ClearData();
        }
    };

     async function CreateQueue() {
        let token = localStorage.getItem("token");
        var data = {
            QueueNumber: QueueNumber,
            LocationID: LocationID,
        }
        await axios.post("/CreateQueue", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getQueueByLocationID();
        }).catch((err) => {
            console.log(err);
        });
    };

    async function getQueueByLocationID() {
        var dateNow = new Date().toISOString().split('T')[0]
        let token = localStorage.getItem("token");
        await axios.get(`/getQueueByLocationID/${LocationID}/${dateNow}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let temOrder = response?.data;
            if(temOrder.length > 0){
            setQueueID(temOrder[0].QueueID);
            setQueueNumber(Number(temOrder[0].QueueNumber) + 1);
            } else {
            setQueueID('');
            setQueueNumber('1');
            }
        }).catch((err) => {
            setQueueID('');
            setQueueNumber('1');
            console.log(err);
        });
    }

    async function getStoreInventory (ProductID, Quantity) {
        let token = localStorage.getItem("token");
        var data = {
            ProductID: ProductID,
            LocationID: LocationID,
        }
        await axios.post("/getStoreInventory",data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let inventoryData = response?.data;
            var gQuantity = 0;
            if(inventoryData.length > 0){
                gQuantity = Number(inventoryData[0].Quantity) - Number(Quantity);
                dropInventory(inventoryData[0].StoreInventoryID, gQuantity);
            } else {
                getIngredientByProductID(ProductID);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    async function getIngredientByProductID (ProductID) {
        if(ProductID){
            let token = localStorage.getItem("token");
            await axios.put(`/getIngredientDetailByProductID/${ProductID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                let temOrder = response?.data;
                if(temOrder.length > 0){
                    for (var i=0; i < temOrder.length; i++) {
                        getStoreInventoryForIngredient(temOrder[i].ProductID, temOrder[i].Size);
                    }  
                }
            }).catch((err) => {
                console.log(err);
            });
        } 
    }

     async function getStoreInventoryForIngredient (ProductID, Quantity) {
        let token = localStorage.getItem("token");
        var data = {
            ProductID: ProductID,
            LocationID: LocationID,
        }
        await axios.post("/getStoreInventory",data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            let inventoryData = response?.data;
            var gQuantity = 0;
            if(inventoryData.length > 0){
                gQuantity = Number(inventoryData[0].Quantity) - Number(Quantity);
                dropInventory(inventoryData[0].StoreInventoryID, gQuantity);
            } 
        }).catch((err) => {
            console.log(err);
        });
    }
    
    async function dropInventory (StoreInventoryID, Quantity) {
        let token = localStorage.getItem("token");
        var data = {
            StoreInventoryID: StoreInventoryID,
            Quantity: Quantity,
        }
        await axios.post("/PosUpdateStoreInventory", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        }).catch((err) => {
            console.log(err);
        });
    }

    // async function UpdateTemOrder () {
    //     let token = localStorage.getItem("token");
    //     var data = {
    //         TableID: TableID,
    //         LocationID: LocationID,
    //     }
    //     await axios.post("/UpdateTemOrderPayment", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
    //     }).catch((err) => {
    //         console.log(err);
    //     });
    // }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    async function DeleteTemOrder () {
        let token = localStorage.getItem("token");
        let data;
        data = {
            LocationID: LocationID,
        };
        await axios.post("/DeleteTemOrder", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    async function DeleteTempTotal () {
        let token = localStorage.getItem("token");
        let data;
        data = {
            LocationID: LocationID,
        };
        await axios.post("/DeleteTempTotal", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            //success
        }).catch((err) => {
            console.log(err);
        });
    }

    const ClearData = () => {
            setTransactionID("");
            setPaidAmount();
            setPaidMoreAmount();
            setDiscountAmount(0);
            setChangeAmount(0);
            
            setMemberID("");
            setMemberNO("");
            setMemberName("0");
            setMemberNewAmount(0);
            setMemberAmount(0);
            setMemberPoint(0);
            setMemberNewPoint(0);

            setGiftCardID("");
            setGiftCardNO("");
            setGiftCardAmount(0);

            setRewardCardID("");
            setRewardCardNO("");
            setRewardName("0");
            setRewardNewPoint(0);
            setRewardPoint(0);

            setTotalPaidAmount(0);
            setPaidAmountByCurrency(0);
            setPaymentType("");
            setPaymentTypeID("");
            setTempOrder([]);
            setSubTotal(0);
            setNetTotal(0);
            setTax(0);
            setShowPayment(false);
            setShowOrder(false);
            setDisblebtnpayment(1);
            localStorage.removeItem('DiscountAmount');
            localStorage.removeItem('PaidAmount');
            localStorage.removeItem('ChangeAmount');
            localStorage.removeItem('TemOrderForViewScreen');
            DeleteTemOrder();
            DeleteTempTotal();
    }

    const onClickClose = () => {
        setTransactionID("");

        setPaidAmount();
        setPaidMoreAmount();
        setDiscountAmount(0);
        setChangeAmount(0);
        
        setMemberID("");
        setMemberNO("");
        setMemberName("0");
        setMemberNewAmount(0);
        setMemberAmount(0);
        setMemberPoint(0);
        setMemberNewPoint(0);

        setGiftCardID("");
        setGiftCardNO("");
        setGiftCardAmount(0);
        setPaymentType("");
        setPaymentTypeID("");
        setRewardCardID("");
        setRewardCardNO("");
        setRewardName("0");
        setRewardNewPoint(0);
        setRewardPoint(0);

        setTotalPaidAmount(0);
        setPaidAmountByCurrency(0);
        setShowPayment(false);
    }

    return (
        <div style={{ display: showPayment ? 'flex' : 'none' }} className="paymentForm">
            <div className="PaymentContents">
                <div className="leftConten">
                    <div className="inputAmout">
                        <div className="selectContent"> 
                            <div className="PaymentType">
                                <label>ປະເພດຈ່າຍ</label>
                                <select className="PaymentType" onChange={(e) => handleSelectPaymentType(e)}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກປະເພດຈ່າຍ'}
                                    </option>,
                                    {PaymentTypeList && PaymentTypeList.map(item => (
                                        <option
                                            key={item.PaymentTypeID}
                                            value={item.PaymentType}
                                        >
                                            {item.PaymentType}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="DiscountType">
                                <label>ສ່ວນຫລຸດ</label>
                                <select className="DiscountType" onChange={(e) => handleSelectDiscountType(e)}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກສ່ວນຫລຸດ'}
                                    </option>,
                                    {
                                        DiscountList && DiscountList.map(item => (
                                        <option
                                            key={item.Discount}
                                            value={item.DiscountType}
                                        >
                                            {item.DiscountType}
                                        </option>
                                    ))}
                                </select>
                                {/* {errors.DiscountType && (
                                    <p className="invalid-feedback">{errors.DiscountType}</p>
                                )} */}
                            </div>
                        </div>
                        <div className="inputContent">
                            <div className="txtPaidAmount">
                                <label>ຍອດຈ່າຍ</label>
                                <input className={`input form-control`} name="PaidAmount" placeholder="ຈ່າຍ" required onClick={(e) => handleInputClick(0)} onChange={(e) => handleInputChange(e)} 
                                value={currencyFormat(PaidAmount)} disabled={PaymentType === "Gift Card" || PaymentType === "Member" || PaymentType === ""}  />
                                {/* {errors.PaidAmount && (
                                    <p className="invalid-feedback">{errors.PaidAmount}</p>
                                )} */}
                            </div>
                            <div className="txtPaidMore">
                                <label>ຈ່າຍເພີ່ມ</label>
                                <input className={`input form-control`} name="PaidMordAmount" placeholder="ຈ່າຍເພີ່ມເງິນສົດ" onClick={(e) =>handleInputClick(1)} required onChange={(e) => handleInputMoreCashChange(e)} 
                                value={currencyFormat(PaidMoreAmount)} disabled={!PaymentType || PaymentType === "Cash" || PaymentType === "CASH"} />
                                {/* {errors.PaidMoreAmount && (
                                    <p className="invalid-feedback">{errors.PaidMoreAmount}</p>
                                )} */}
                            </div>
                        </div>
                    </div>
                        <div className="inputMoneyContent">
                            <div className="group1">
                                <div className="money" onClick={(e) => hanldeclickMoney(500)}>
                                    <img src={kip500} />
                                </div>
                                <div className="money" onClick={(e) => hanldeclickMoney(1000)}>
                                    <img src={kip1000} />
                                </div>
                                <div className="money" onClick={(e) => hanldeclickMoney(2000)}>
                                    <img src={kip2000} />
                                </div>
                            </div>
                            <div className="group2">
                                <div className="money" onClick={(e) => hanldeclickMoney(5000)}>
                                    <img src={kip5000} />
                                </div>
                                <div className="money" onClick={(e) => hanldeclickMoney(10000)}>
                                    <img src={kip10000} />
                                </div>
                                <div className="money" onClick={(e) => hanldeclickMoney(20000)}>
                                    <img src={kip20000} />
                                </div>
                            </div>
                            <div className="group3">
                                <div className="money" onClick={(e) => hanldeclickMoney(50000)}>
                                    <img src={kip50000} />
                                </div>
                                <div className="money" onClick={(e) => hanldeclickMoney(100000)}>
                                    <img src={kip100000} />
                                </div>
                            </div>
                        </div>
                    <div className="footer">

                    </div>
                </div>
                <div className="rightContent">
                    <div className="Header">
                        <div className="headerPrintcount">
                            <span>ຈຳນວນບິນ:</span>
                            <input className="PrintCount" type="text" name="PrintCount" placeholder="1" onChange={(e) => handleInputPrintCount(e)} value={PrintCount} required />
                        </div>
                        <div className="btnclose" onClick={e => onClickClose()}>X</div>
                    </div>
                    <div className="body">
                        <div className="subtotal">
                            <span>ຍອດລວມ:</span>
                            <strong>{currencyFormat(subTotal)}</strong>
                        </div>
                        <div className="discout">
                            <span>ສ່ວນຫລຸດ:</span>
                            <strong>{<input className={`input form-control`} name="Discount" placeholder="0" required onChange={(e) => handleChangeDiscount(e)} 
                                value={currencyFormat(DiscountAmount)} />}</strong> 
                        </div>
                        <div className="tax">
                            <span>Tax:</span>
                            <strong>{currencyFormat(Tax) || '0'}</strong>
                        </div>
                        <div className="nettotal">
                            <span>ຍອດລວມຕ້ອງຈ່າຍ:</span>
                            <strong>{currencyFormat(NewNetTotal) || '0'}</strong>
                        </div>
                        <div className="footer-line"></div>
                        <div className="paidAmount">
                            <span>ຍອດຈ່າຍ:</span>
                            <strong>{currencyFormat(PaidAmount) || '0'}</strong>
                        </div>
                        <div className="changeAmount">
                            <span>ເງິນທອນ:</span>
                            <strong>{currencyFormat(ChangeAmount) || '0'}</strong>
                        </div>
                    </div>
                    <div className="memberCardContent">
                       { PaymentType == 'Member' && 
                            <div className="MemerCard">
                                <div className="CardNumber">
                                    <label>ເລກບັດ Member</label>
                                    <input className={`input form-control`} type="text" name="MemberNO"  onChange={(e) => handleSearchMembers(e)} value={MemberNO || ''} required />
                                </div>
                                
                                <div className="Name">
                                    <label>ຊື່ </label>
                                    <span>{MemberName}</span>
                                </div>
                                <div className="Balance">
                                    <label>Balance</label>
                                    <span>{MemberAmount}</span>
                                </div>
                                <div className="NewBalance">
                                    <label>New Balance:</label>
                                    <span>{MemberNewAmount}</span>
                                </div>
                            </div>
                        }

                        { LocationName !="BIC" && PaymentType !== 'Member' && PaymentType !== 'Gift Card' && 
                            <div className="MemerCard">
                                <div className="CardNumber">
                                    <label>ເລກບັດ Reward</label>
                                    <input className={`input form-control`} type="text" name="RewardNO"  onChange={(e) => handleSearchRewardCard(e)} value={RewardCardNO || ''} required />
                                </div>
                                
                                <div className="Name">
                                    <label>ຊື່ </label>
                                    <span>{RewardName}</span>
                                </div>
                                <div className="Balance">
                                    <label>Point</label>
                                    <span>{RewardPoint}</span>
                                </div>
                                <div className="NewBalance">
                                    <label>New Point:</label>
                                    <span>{RewardNewPoint}</span>
                                </div>
                            </div>
                        }
                        { LocationName !="BIC" && PaymentType == 'Gift Card' && 
                            <div className="MemerCard">
                                <div className="CardNumber">
                                    <label>ເລກບັດ Gift Card</label>
                                    <input className={`input form-control`} type="text" name="GiftCardNO"  onChange={(e) => handleSearchGiftCard(e)} value={GiftCardNO || ''} required />
                                </div>
                                <div className="NewBalance">
                                    <label>ລາຄາບັດ:</label>
                                    <span>{GiftCardAmount}</span>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="footer">
                        <div className="btn-Payment">
                            <button className="btn" onClick={(e) => saveTutorial()} disabled={!disblebtnpayment}>ຈ່າຍເງິນ</button>
                            {/* <button className="btn" onClick={(e)=> connectPrinter()}>conntect</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Payment;
